<div
    fxLayout="row"
    fxLayoutAlign="space-between center"
    class="toolbar-wrapper"
>
    <section class="left" fxLayout="row" fxLayoutAlign="start center">
        <button mat-icon-button class="menu-icon" (click)="menuToggle.emit()">
            <nb-icon icon="menu-outline"></nb-icon>
        </button>
    </section>
    <section
        class="right"
        fxLayout="row"
        fxLayoutAlign="end center"
        fxLayoutGap="12px"
    >
        <div
            class="theme-toggle-container"
            (click)="toggleDarkMode()"
            [matTooltip]="
                (darkMode$ | async)
                    ? 'Schimbă la Mod Luminos'
                    : 'Schimbă la Mod Întunecat'
            "
        >
            <nb-icon icon="sun-outline" class="toggle-icon sun"></nb-icon>
            <div class="toggle-track" [class.dark]="darkMode$ | async">
                <div class="toggle-thumb"></div>
            </div>
            <nb-icon icon="moon-outline" class="toggle-icon moon"></nb-icon>
        </div>
        <a class="tapp-link user" [matMenuTriggerFor]="beforeMenu">
            <span>Admin</span>
            <mat-icon>keyboard_arrow_down</mat-icon>
        </a>
        <mat-menu #beforeMenu="matMenu" xPosition="before">
            <button mat-menu-item (click)="logout()">Logout</button>
        </mat-menu>
    </section>
</div>
